import { getValueByPath } from '@shared/utils/get-value-by-path.util';

export function groupBy<T, B = T[]>(
  list: T[],
  key?: keyof T | ((item: T) => string),
  transform?: (group: any, item: T) => Record<keyof T, B>
): Record<keyof T, B> {
  return list.reduce((acc, item) => {
    const groupKey = typeof key === 'undefined' ? 'id' : (key as any);
    const groupId = typeof groupKey === 'string' ? getValueByPath(item, groupKey) : groupKey(item);
    if (transform) {
      acc[groupId] = transform(acc[groupId], item);
    } else {
      acc[groupId] = acc[groupId] || [];
      acc[groupId].push(item);
    }
    return acc;
  }, {} as Record<keyof T, B>);
}
